module.exports = __webpack_public_path__ + "img/1120368856.175f02b3.png";